import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

const _import = file => () => import('@/views/' + file + '.vue')

Vue.use(Router)

const router = new Router({
  // 解决路由跳转页面没有置顶
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  mode: 'history',
  routes: [
    // 首页
    {
      path: '/home',
      name: 'home',
      component: _import('home/index'),
      meta: {
        title: '首页',
        keepAlive: false
      }
    },
    // 尽调
    {
      path: '/due-diligence',
      name: 'dueDiligence',
      component: _import('dueDiligence/index'),
      children: [
        // 我的问卷
        {
          path: 'myquestionnaire',
          name: 'myquestionnaire',
          component: _import('dueDiligence/myquestionnaire'),
          children: [
            // 采集信息
            {
              path: 'creat-authinfo',
              name: 'creatAuthinfo',
              component: _import('dueDiligence/creatAuthinfo')
            }
          ]
        },
        // 调查问卷
        {
          path: 'questionnaire',
          name: 'questionnaire',
          component: _import('dueDiligence/questionnaire/questionnaire')
        },
        // 代办尽调
        {
          path: 'agentQuestionnaire',
          name: 'agentQuestionnaire',
          component: _import('dueDiligence/agentQuestionnaire'),
          children: [
            // 新增代办问卷
            {
              path: 'bind-survey',
              name: 'bindSurvey',
              component: _import('dueDiligence/bindSurvey')
            }
          ]
        }
      ],
      meta: {
        title: '尽调',
        keepAlive: false
      }
    },
    // 我的
    {
      path: '/mine',
      name: 'mine',
      component: _import('mine/index'),
      children: [
        // 设置页面
        {
          path: 'set',
          name: 'set',
          component: _import('mine/set/index'),
          children: [
            // 用户更正信息
            {
              path: 'updateUserInfo',
              name: 'updateUserInfo',
              component: _import('mine/set/updateUserInfo')
            },
            // 账号注销
            {
              path: 'unsubscribe',
              name: 'unsubscribe',
              component: _import('mine/set/unsubscribe')
            },
            // 隐私政策
            {
              path: 'privacyPolicy',
              name: 'privacyPolicy',
              component: _import('mine/set/privacyPolicy')
            },
            // 账户协议
            {
              path: 'userAgreement',
              name: 'userAgreement',
              component: _import('mine/set/userAgreement')
            },
            // 授权管理
            {
              path: 'devicePermission',
              name: 'devicePermission',
              component: _import('mine/set/devicePermission'),
              children: [
                // 定位详情
                {
                  path: 'location',
                  name: 'location',
                  component: _import('mine/set/permissionDescription/location')
                },
                // 相机详情
                {
                  path: 'camera',
                  name: 'camera',
                  component: _import('mine/set/permissionDescription/camera')
                },
                // 麦克风详情
                {
                  path: 'audio',
                  name: 'audio',
                  component: _import('mine/set/permissionDescription/audio')
                },
                // 存储、相册详情
                {
                  path: 'storage',
                  name: 'storage',
                  component: _import('mine/set/permissionDescription/storage')
                }
              ]
            }
          ]
        }
      ],
      meta: {
        title: '我的',
        keepAlive: false
      }
    },
    // 消息
    {
      path: '/message',
      name: 'message',
      component: _import('message/index'),
      meta: {
        title: '消息',
        keepAlive: false
      }
    },
    // 我的合同
    {
      path: '/contract',
      name: 'contract',
      component: _import('contract/index'),
      children: [
        // 合同详情
        {
          path: 'contractDetail',
          name: 'contractDetail',
          component: _import('contract/contractDetail')
        },
        // 签署前置合同
        {
          path: 'contractPreSign',
          name: 'contractPreSign',
          component: _import('contract/contractPreSign')
        }
      ],
      meta: {
        title: '合同',
        keepAlive: false
      }
    },
    // 京东金融企业主贷贷后尽调
    {
      path: '/survey',
      name: 'survey',
      component: _import('survey/index'),
      children: [
        // 我的问卷
        {
          path: 'myquestionnaire',
          name: 'myquestionnaire-JDJR',
          component: _import('survey/myquestionnaire')
        },
        // 调查问卷
        {
          path: 'survey-detail',
          name: 'survey-detail',
          component: _import('survey/questionnaire/index'),
          children: [
            // 问卷大类
            {
              path: 'category-list',
              name: 'category-list',
              component: _import('survey/questionnaire/categoryList')
            },
            // 调查问卷详情
            {
              path: 'question-content',
              name: 'question-content',
              component: _import('survey/questionnaire/questionContent')
            }
          ]
        },
        // 消息
        {
          path: 'message/:surveyNo',
          name: 'message-JDJR',
          component: _import('survey/message')
        }
      ],
      meta: {
        title: '尽调',
        keepAlive: false
      }
    },
    // 企业金融尽调
    {
      path: '/survey-e',
      name: 'survey-e',
      component: _import('survey-e/index'),
      children: [
        // 我的问卷
        {
          path: 'myquestionnaire',
          name: 'myquestionnaire-e',
          component: _import('survey-e/myquestionnaire'),
          children: [
            // 采集信息
            {
              path: 'creat-authinfo',
              name: 'creatAuthinfo-e',
              component: _import('survey-e/creatAuthinfo')
            }
          ]
        },
        // 调查问卷
        {
          path: 'questionnaire',
          name: 'questionnaire-e',
          component: _import('survey-e/questionnaire/questionnaire')
        },
        // 代办尽调
        {
          path: 'agentQuestionnaire',
          name: 'agentQuestionnaire-e',
          component: _import('survey-e/agentQuestionnaire'),
          children: [
            // 新增代办问卷
            {
              path: 'bind-survey',
              name: 'bindSurvey-e',
              component: _import('survey-e/bindSurvey')
            }
          ]
        },
        // 消息
        {
          path: 'message/:surveyNo',
          name: 'message-JBFAPP',
          component: _import('survey-e/message')
        }
      ],
      meta: {
        title: '尽调',
        keepAlive: false
      }
    },
    // 引导页面
    {
      path: '/guide',
      name: 'guide',
      component: _import('guide'),
      meta: {
        title: '引导页',
        keepAlive: false
      }
    }
  ]
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
  if (to.path.indexOf('/home') === 0) {
    store.commit('global/SET_ACTIVETABBAR', 'home')
  } else if (to.path.indexOf('/due-diligence') === 0) {
    store.commit('global/SET_ACTIVETABBAR', 'due-diligence')
  } else if (to.path.indexOf('/message') === 0) {
    store.commit('global/SET_ACTIVETABBAR', 'message')
  } else if (to.path.indexOf('/mine') === 0) {
    store.commit('global/SET_ACTIVETABBAR', 'mine')
  } else if (to.path.indexOf('/contract') === 0) {
    store.commit('global/SET_ACTIVETABBAR', 'contract')
  } else if (to.path.indexOf('/survey') === 0) {
    store.commit('global/SET_ACTIVETABBAR', 'survey')
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js